 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781771481601_COVER from '@/components/9781771481601_Cover'
 import EBB from '@/components/EBB'
 import TLU from '@/components/TLU'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import PRAISE from '@/components/praise'
 import A781771481601_TITLE_PAGE from '@/components/9781771481601_Title_Page'
 import A781771481601_DEDICATION from '@/components/9781771481601_Dedication'
 import A781771481601_EPIGRAPH from '@/components/9781771481601_Epigraph'
 import A781771481601_CONTENTS from '@/components/9781771481601_Contents'
 import A781771481601_PROLOGUE from '@/components/9781771481601_Prologue'
 import A781771481601_CHAPTER_ONE from '@/components/9781771481601_Chapter_One'
 import A781771481601_CHAPTER_TWO from '@/components/9781771481601_Chapter_Two'
 import A781771481601_CHAPTER_THREE from '@/components/9781771481601_Chapter_Three'
 import A781771481601_CHAPTER_FOUR from '@/components/9781771481601_Chapter_Four'
 import A781771481601_CHAPTER_FIVE from '@/components/9781771481601_Chapter_Five'
 import A781771481601_CHAPTER_SIX from '@/components/9781771481601_Chapter_Six'
 import A781771481601_CHAPTER_SEVEN from '@/components/9781771481601_Chapter_Seven'
 import A781771481601_CHAPTER_EIGHT from '@/components/9781771481601_Chapter_Eight'
 import A781771481601_AUTHORS_NOTE from '@/components/9781771481601_Authors_Note'
 import LOVE_2 from '@/components/love_2'
 import ATA from '@/components/ata'
 import COPYRIGHT from '@/components/copyright'
 import BACKEDAUBA from '@/components/Backed/auba'
 import ENDMATTER02 from '@/components/endmatter02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781771481601_Contents",
 			"name" : "9781771481601_Contents",
 			"component" : A781771481601_CONTENTS
 		},
 		{
 			"path" : "/9781771481601_Prologue",
 			"name" : "9781771481601_Prologue",
 			"component" : A781771481601_PROLOGUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js